import { cEl } from '../../../util';
import Overview from './Overview';
import Delivery from './Delivery';
import Guide from './Guide';
import Clean from './Clean';
import { navigateTo } from '../../AppHeader/Link';
import { PATH_TEST } from '../../path';

function Learn() {
    const learnContainer = cEl('div');
    learnContainer.classList.add('learn-container');

    const buttonWrapper = cEl('div');
    buttonWrapper.classList.add('button-wrapper');
    buttonWrapper.style['margin-top'] = '40px';

    const testButton = cEl('button');
    testButton.classList.add('button', 'brand-button');
    testButton.innerHTML = '자가진단 테스트 시작하기';
    testButton.addEventListener('click', e => {
        navigateTo(PATH_TEST);
    });

    buttonWrapper.appendChild(testButton);

    learnContainer.append(Overview(), Delivery(), Guide(), Clean(), buttonWrapper);
    return learnContainer;
}

export default Learn;
